function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 129,
  y: 68,
  width: 198,
  height: 146,
  fill: "#FFFAEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.909 141.785C257.451 141.386 257.451 140.576 256.909 140.176L246.094 132.197C245.433 131.71 244.5 132.181 244.5 133.002V148.96C244.5 149.78 245.433 150.251 246.094 149.764L256.909 141.785ZM231 141.481C231 143.69 229.209 145.481 227 145.481C224.791 145.481 223 143.69 223 141.481C223 139.272 224.791 137.481 227 137.481C229.209 137.481 231 139.272 231 141.481ZM211 141.481C211 143.69 209.209 145.481 207 145.481C204.791 145.481 203 143.69 203 141.481C203 139.272 204.791 137.481 207 137.481C209.209 137.481 211 139.272 211 141.481Z",
  fill: "#F08B04"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_s3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M172.653 150.893C166.642 175.002 142.223 189.675 118.11 183.663C94.0072 177.652 79.3342 153.231 85.348 129.123C91.3561 105.01 115.775 90.3358 139.881 96.3468C163.992 102.358 178.664 126.781 172.653 150.893Z",
  fill: "url(#paint0_linear_s3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.836 133.594C149.731 127.605 145.172 124.386 138.937 122.238L140.96 114.126L136.022 112.896L134.053 120.794C132.755 120.471 131.422 120.165 130.097 119.863L132.08 111.913L127.145 110.682L125.121 118.791C124.046 118.547 122.992 118.305 121.968 118.05L121.973 118.025L115.164 116.324L113.85 121.598C113.85 121.598 117.514 122.438 117.436 122.49C119.436 122.989 119.798 124.313 119.737 125.362L117.433 134.603C117.571 134.639 117.75 134.689 117.947 134.768C117.782 134.727 117.606 134.682 117.425 134.639L114.196 147.585C113.951 148.192 113.331 149.103 111.933 148.757C111.982 148.829 108.344 147.862 108.344 147.862L105.893 153.514L112.318 155.116C113.514 155.415 114.685 155.729 115.839 156.024L113.795 164.229L118.727 165.46L120.751 157.342C122.099 157.708 123.406 158.045 124.686 158.363L122.67 166.443L127.607 167.674L129.651 159.484C138.071 161.078 144.403 160.435 147.068 152.819C149.215 146.687 146.961 143.15 142.531 140.844C145.757 140.1 148.187 137.977 148.836 133.594ZM137.553 149.414C136.027 155.546 125.703 152.231 122.356 151.4L125.067 140.53C128.415 141.365 139.148 143.019 137.553 149.414ZM139.081 133.505C137.688 139.083 129.095 136.249 126.308 135.554L128.766 125.695C131.554 126.39 140.531 127.687 139.081 133.505Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_s3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 330.5,
  cy: 140.5,
  r: 44.5,
  fill: "#FFFAEE"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M354.624 114.102C341.259 101.88 320.774 101.88 307.408 114.102L304.88 111.631C319.628 98.029 342.348 98.029 357.096 111.631L354.624 114.102ZM356.915 116.359L359.386 113.888V113.83C372.988 128.578 372.988 151.299 359.386 166.046L356.915 163.575C369.136 150.209 369.136 129.725 356.915 116.359ZM305.102 163.6C292.896 150.237 292.896 129.771 305.102 116.408L302.631 113.937C289.029 128.685 289.029 151.405 302.631 166.153L305.102 163.6ZM307.384 165.881C320.75 178.104 341.234 178.104 354.6 165.881L357.129 168.352C342.381 181.954 319.661 181.954 304.913 168.352L307.384 165.881Z",
  fill: "url(#paint1_linear_s3)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.488 133.707C338.488 138.649 330.761 138.048 328.307 138.048V129.341C330.761 129.341 338.488 128.567 338.488 133.707ZM340.506 147.224C340.506 152.628 331.247 152.01 328.299 152.01V142.422C331.247 142.43 340.506 141.582 340.506 147.224ZM346.602 131.755C346.107 126.598 341.659 124.868 336.033 124.341V117.232H331.684V124.201C330.539 124.201 329.369 124.201 328.208 124.242V117.232H323.883V124.382H321.116H315.07V129.036C315.07 129.036 318.282 128.979 318.233 129.036C319.437 128.904 320.529 129.749 320.704 130.947V150.527C320.651 151.377 319.92 152.022 319.071 151.97C319.066 151.97 319.061 151.97 319.056 151.969C319.114 152.018 315.893 151.969 315.893 151.969L315.028 157.167H320.696H323.809V164.432H328.158V157.274H331.635V164.399H335.992V157.216C343.34 156.771 348.463 154.959 349.106 148.081C349.625 142.545 347.022 140.074 342.862 139.078C345.391 137.793 346.981 135.527 346.602 131.755Z",
  fill: "url(#paint2_linear_s3)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M330.992 98.5091C308.091 98.5231 289.536 117.099 289.55 140C289.564 162.901 308.14 181.456 331.041 181.442C353.927 181.428 372.474 162.876 372.483 139.992C372.456 117.094 353.89 98.5428 330.992 98.5338V98.5091ZM330.992 185C306.139 184.996 285.995 164.845 286 139.992C286.005 115.138 306.156 94.9951 331.008 95C355.855 95.0049 375.996 115.145 376 139.992C375.973 164.838 355.838 184.973 330.992 185Z",
  fill: "url(#paint3_linear_s3)"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_s3",
  x: 76,
  y: 89,
  width: 106,
  height: 106.011,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_s3",
  x: 276,
  y: 86,
  width: 109,
  height: 109,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_s3",
  x1: 174,
  y1: 95,
  x2: 174,
  y2: 185.011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EE12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB23F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEC062"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_s3",
  x1: 292,
  y1: 101,
  x2: 369.587,
  y2: 178.554,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EE12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB23F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEC062"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_s3",
  x1: 319,
  y1: 120,
  x2: 349.171,
  y2: 164.432,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EE12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB23F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEC062"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_s3",
  x1: 286,
  y1: 72,
  x2: 349,
  y2: 177,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EE12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB23F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEC062"
})));

var SvgStep3 = function SvgStep3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 282,
    viewBox: "0 0 460 282",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step3.53d84704.svg";
export { ForwardRef as ReactComponent };